export default __webpack_public_path__ + "static/media/left_arrow_green.9f587433.svg";